import { render, staticRenderFns } from "./AddStaffMemberModalComponent.vue?vue&type=template&id=756c3b35&scoped=true&"
import script from "./AddStaffMemberModalComponent.vue?vue&type=script&lang=js&"
export * from "./AddStaffMemberModalComponent.vue?vue&type=script&lang=js&"
import style0 from "./AddStaffMemberModalComponent.vue?vue&type=style&index=0&id=756c3b35&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "756c3b35",
  null
  
)

export default component.exports